module.exports = __webpack_public_path__ + "img/img_company_opinion3.6ae7ace3.svg";